import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from './new-request.actions';
import { DatePicker, Col, Row, Form, Modal, Select, Input, Upload, Icon, Checkbox, Tooltip, message } from 'antd';
import { dspxGetChildrens, dspxGetRoomOptions, dspxGetWorkerChildrens } from '../../helpers/dspx-utils'
import IconCheckBox from '../../components/icon-checkbox';
import { PossWarrantyIcon, UrgentIcon, ToolIcon } from '../../resource/icons';
import moment from 'moment'
import { ReactComponent as AddRequestIcon } from '../../resource/forms/ListPlus.svg';
import { toDateStr } from '../../helpers/utcDate';
import { SipPhoneContext } from '../../components/SipPhoneProvider';
import { SIP_STATUS_REGISTERED } from '../../components/SipPhoneProvider/constants/statuses';
import { acceptanceParentServiceId } from '../../constants/requests.constants';
import OwnerFieldsRow from './components/OwnerFieldsRow/OwnerFieldsRow';
import { PriorityList } from '../../components/requestComponents';
import { ActiveShutdowns } from './components/ActiveShutdowns';
import { MODAL_UNSAVED_DATA_WARNING_TITLE, UNSAVED_DATA_WARNING_TEXT } from '../../constants/text.constants';
import ChargeableCheckbox from './components/ChargeableCheckbox';
import { createFullAddress } from '../../helpers/createFullAddress';

const { TextArea } = Input;

const defaultCreationMethodId = '1';
const defaultCreationMethodIdContactCenter = '3';
const defaultCreationMethodIdWeb = '8';

const getAvailableCreationMethods = (creationMethods = [], isDispetcher) => {
  const filtered = creationMethods.filter(
    (method) => method.canSetManually === true
  );

  if (!isDispetcher) return filtered;

  const hasContactCenter = filtered.some((method) => method.id === 3);
  if (hasContactCenter) return filtered;

  const contactCenter = creationMethods.find((method) => method.id === 3);

  if (!contactCenter) return filtered;

  return [...filtered, contactCenter];
};

const NewRequestForm = Form.create()(
	class extends React.Component {
		static contextType = SipPhoneContext;

		constructor(props) {
			super(props)

			this.state = {
				fileList: [],
			}
		}

		componentDidUpdate(prevProps) {
      const { fprops, form } = this.props;
      const { termOfExecution, valuePossInternal } = fprops;
      const { termOfExecution: prevTermOfExecution, valuePossInternal: prevValuePossInternal } = prevProps.fprops;

      if (termOfExecution !== prevTermOfExecution) {
        form.setFieldsValue({
          executeMoment: termOfExecution ? moment(termOfExecution) : undefined,
        });
      }

			if (valuePossInternal !== prevValuePossInternal) {
        form.setFieldsValue({
        	IsInternal: valuePossInternal
        });
      }
    }

		handleExecuterChange = v => {
			this.props.dispatch(actions.setExecuterValue(v))
		}

		handleWorkerChange = v => {
			this.props.dispatch(actions.setWorkerValue(v))
		}

		handleOwnerInfoCheckboxClick = (e) => {
			this.props.dispatch(actions.setOwnerInfo(e.target.checked))
		}

		handlePossWarranty = (checked) => {
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(actions.applyPossWarranty(checked));			
		}

		handlePossInternal = (checked) => {
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(actions.applyPossInternal(checked));			
		}

		handleServiceChange = (value) => {
			this.props.form.resetFields(['typeId']);
			this.props.dispatch(actions.applySubservice(undefined));
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.form.getFieldValue()
			this.props.dispatch(actions.applyService(value));
		}

		handleSubserviceChange = (value, option) => {
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId']);

			const data = option.props.data || {};
			if (data.hasOwnProperty('isImmediate')) {
				this.props.form.setFieldsValue({ isImmediate: data.isImmediate })
			}
			//this.props.dispatch(actions.setSubserviceValue(value));
			this.props.dispatch(actions.applySubservice(value));
		}

		handleAddrStreetChange = (value) => {
			this.props.form.resetFields(['addressId']);
			this.props.dispatch(actions.applyAddrFlat(undefined));
			this.props.form.resetFields(['serviceId'])
			this.props.form.resetFields(['typeId']);
			this.props.dispatch(actions.applySubservice(undefined));
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(actions.applyAddrStreet(value));
      if(this.props.fprops.stageLife) {
				this.props.dispatch(actions.clearStagesLife())
			}
		}

    handleServiceCompanyChange = (value) => {
      this.props.form.resetFields(['addressId']);
			this.props.dispatch(actions.applyAddrFlat(undefined));
			this.props.form.resetFields(['serviceId'])
			this.props.form.resetFields(['typeId']);
			this.props.dispatch(actions.applySubservice(undefined));
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
      this.props.dispatch(actions.applyAddrStreet(undefined));
      this.props.dispatch(actions.applyAddrServiceCompany(value));
      if(this.props.fprops.stageLife) {
				this.props.dispatch(actions.clearStagesLife())
			}

    }
		
		handleAddrBuildingChange = (value) => {
			this.props.form.resetFields(['addressId']);
			this.props.dispatch(actions.applyAddrFlat(undefined));
			this.props.form.resetFields(['serviceId'])
			this.props.form.resetFields(['typeId']);
			this.props.dispatch(actions.applySubservice(undefined));
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(actions.applyAddrBuilding(value));
      if(this.props.fprops.stageLife) {
				this.props.dispatch(actions.clearStagesLife())
			}
		}

		handleAddrFlatChange = async (value) => {
			this.props.form.resetFields(['masterId'])
			this.props.form.resetFields(['executerId'])
			this.props.dispatch(actions.applyAddrFlat(value));
			this.props.dispatch(actions.fetchGetStagesLife(value))
		}

		isInputDisabled = (workers) => {
			return (
				Number(this.props.fprops?.valueService) === acceptanceParentServiceId &&
				this.props.fprops?.valueSubservice &&
				(!workers || workers[0]?.autoSet)
			);
		};

		render() {
			const { visible, onCancel, onCreate, form, fprops, asModal = true } = this.props;
			const request = fprops.record
			const { getFieldDecorator, setFieldsValue, getFieldValue } = form;
			const { sip, call } = this.context;
			const { CanChangeWarranty, CanAddFileToRequest } = fprops.userInfo;

			const isConnected = sip.status === SIP_STATUS_REGISTERED
      const canBindCall = isConnected && call.info?.id;

			const edate = this.props.form.getFieldValue('executeMoment')
			//console.log(this.props.form.getFieldValue('executeMoment'))
			const isWorker = this.props.form.getFieldValue('WorkerId')
			const isExecuter = this.props.form.getFieldValue('executerId')

			const data = {
				stages: "Строителдьство"
			}// 'это будет получение стадии помещения

      const dispatcherDispexValue = 'Own';
      const dispatcherValue = 'Other';
      const showServiceCompeny = this.props.fprops.userInfo.Dispatcher === dispatcherDispexValue;

      const isDispetcher = this.props.fprops.userInfo.Dispatcher === dispatcherDispexValue || this.props.fprops.userInfo.Dispatcher === dispatcherValue;

      const isImmediateValue = getFieldValue('isImmediate')
      const alertDateValue = getFieldValue('alertDate')

      const handleChangeImmediate = (value) => {
        if (!!alertDateValue) return;

        setFieldsValue({
          alertDate: !!value ? moment().add(30, 'minutes') : null,
        })
      }
      
      const content = (
        <Form layout="vertical">

          {showServiceCompeny && (
            <Row>
              <Col span={24}>
                <Form.Item label='Управляющая компания'>
                  <Select 
                    placeholder='УК'
                    notFoundContent='нет данных'
                    allowClear
                    showSearch
                    optionFilterProp="searchtext"
                    value={(fprops.listAddrServiceCompany && fprops.listAddrServiceCompany.some(e => e.id == fprops.valueAddrServiceCompany)) 
                        ? ''+fprops.valueAddrServiceCompany : undefined}
                    onChange={this.handleServiceCompanyChange}
                  >
                    {dspxGetChildrens(fprops.listAddrServiceCompany)}
                  </Select>
                </Form.Item>
              </Col>  
            </Row>
          )}

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={this.props.fprops.stageLife ? <span>Адрес<span style={{ marginLeft: '15px' }}>{this.props.fprops.stageLife}</span></span> : 'Адрес'}>
                {/* <Input.Group compact> */}
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    showSearch
                    dropdownMatchSelectWidth={false}
                    style={{ width: '100%' }}
                    placeholder="Улица"
                    notFoundContent='нет данных'
                    value={(fprops.listAddrStreet && fprops.listAddrStreet.some(e => e.id == fprops.valueAddrStreet)) 
                      ? ''+fprops.valueAddrStreet : undefined}
                    onChange={this.handleAddrStreetChange}
                    optionLabelProp="label"
                    optionFilterProp="searchtext" >
                    {dspxGetChildrens(fprops.listAddrStreet)}
                  </Select>
              
               
                {/* </Input.Group> */}
              </Form.Item>
              <div style={{display: 'flex', gap: 10}}>
                 <Form.Item style={{flex: 1}}>    <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    showSearch
                    style={{ width: '100%' }}
                    notFoundContent='нет данных'
                    placeholder="Дом"
                    optionFilterProp="searchtext"
                    value={(fprops.listAddrBuilding && fprops.listAddrBuilding.some(e => e.id == fprops.valueAddrBuilding)) 
                      ? ''+fprops.valueAddrBuilding : undefined}
                    onChange={this.handleAddrBuildingChange} >
                    {dspxGetChildrens(fprops.listAddrBuilding)}
                  </Select></Form.Item>
              <Form.Item style={{flex: 1}}>   {getFieldDecorator('addressId', {
                    //initialValue: fprops.valueAddrFlat,
                    initialValue: (fprops.listAddrFlat && fprops.listAddrFlat.some(e => e.id == fprops.valueAddrFlat)) 
                    ? ''+fprops.valueAddrFlat : undefined,

                    rules: [{ required: true, message: 'Пожалуйста, выберите адрес.' }]
                  })(
                    <Select
                      getPopupContainer={(trigger) => trigger.parentNode}
                      showSearch
                      notFoundContent='нет данных'
                      style={{ width: '100%' }}
                      placeholder="Помещения"
                      // dropdownMatchSelectWidth={false}
                      onChange={this.handleAddrFlatChange}
                      optionFilterProp="searchtext" >
                      {dspxGetRoomOptions(fprops.listAddrFlat)}
                    </Select>)}</Form.Item>
              </div>
             
            </Col>
          </Row>

          {fprops.listAddrBuilding?.some(
            (e) => e.id == fprops.valueAddrBuilding
          ) && (
            <Row style={{ marginBottom: '20px' }}>
              <Col span={24}>
                <ActiveShutdowns houseId={fprops.valueAddrBuilding} />
              </Col>
            </Row>
          )}
          
          <Row gutter={16}>
            <Col span={24}>
              {getFieldDecorator('addOwnerInfo', { initialValue: fprops.ownerInfo, valuePropName: 'checked' })(
                <Checkbox style={{ marginBottom: 10 }}
                  //disabled={!isExecuter}
                  onClick={this.handleOwnerInfoCheckboxClick}
                >
                  Добавить информацию о заявителе
          </Checkbox>)}
            </Col>
          </Row>
          {fprops.ownerInfo &&
            <OwnerFieldsRow form={form} />
          }

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Услуга">
                <Input.Group compact>
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    showSearch
                    style={{ width: '50%' }}
                    placeholder="услуга"
                    notFoundContent='нет данных'
                    value={(fprops.listService && fprops.listService.some(e => e.id == fprops.valueService)) 
                      ? ''+fprops.valueService : undefined}
                  onChange={this.handleServiceChange}
                    optionFilterProp="searchtext" >
                    {dspxGetChildrens(fprops.listService)}
                  </Select>
                  {getFieldDecorator('typeId', {										
                    initialValue: (fprops.listSubservice && fprops.listSubservice.some(e => e.id == fprops.valueSubservice)) 
                    ? ''+fprops.valueSubservice : undefined,
                    rules: [{ required: true, message: 'Пожалуйста, выберите услугу' }]
                  })(
                    <Select
                      getPopupContainer={(trigger) => trigger.parentNode}
                      showSearch
                      style={{ width: '50%' }}
                      placeholder="причина"
                      notFoundContent='нет данных'
                      optionFilterProp="searchtext" 
                      onChange={this.handleSubserviceChange}>
                      {dspxGetChildrens(fprops.listSubservice, undefined, true)}
                    </Select>)}
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Мастер">
                <Tooltip
                  title={
                    this.isInputDisabled(fprops.listWorker) &&
                    'Изменить нельзя, устанавливается автоматически'
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {getFieldDecorator('masterId', {
                    initialValue:
                      fprops.listWorker &&
                      fprops.listWorker.some(
                        (e) => e.id == fprops.valueWorker
                      )
                        ? '' + fprops.valueWorker
                        : fprops.listWorker &&
                          fprops.listWorker[0] &&
                          fprops.listWorker[0].autoSet
                        ? fprops.listWorker[0].id + ''
                        : undefined,

                    //rules: [{ required: true, message: 'Пожалуйста, выберите мастера' }]
                  })(
                    <Select
                      getPopupContainer={(trigger) => trigger.parentNode}
                      showSearch
                      allowClear
                      placeholder="мастер"
                      notFoundContent="нет данных"
                      optionLabelProp="label"
                      optionFilterProp="searchtext"
                      onChange={this.handleWorkerChange}
                      disabled={this.isInputDisabled(fprops.listWorker)}
                    >
                      {dspxGetWorkerChildrens(fprops.listWorker)}
                    </Select>
                  )}
                </Tooltip>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Исполнитель">
                <Tooltip
                  title={
                    this.isInputDisabled(fprops.listExecuter) &&
                    'Изменить нельзя, устанавливается автоматически'
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                {getFieldDecorator('executerId', {
                  initialValue:
                    fprops.listExecuter &&
                    fprops.listExecuter.some(
                      (e) => e.id == fprops.valueExecuter
                    )
                      ? '' + fprops.valueExecuter
                      : fprops.listExecuter &&
                        fprops.listExecuter[0] &&
                        fprops.listExecuter[0].autoSet
                      ? fprops.listExecuter[0].id + ''
                      : undefined,
                })(
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    showSearch
                    allowClear
                    placeholder="исполнитель"
                    notFoundContent="нет данных"
                    optionLabelProp="label"
                    optionFilterProp="searchtext"
                    onChange={this.handleExecuterChange}
                    disabled={this.isInputDisabled(fprops.listExecuter)}
                  >
                    {dspxGetWorkerChildrens(fprops.listExecuter)}
                  </Select>
                )}
              </Tooltip>
                
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Способ создания">
                {getFieldDecorator('CreationMethodId', {
                    initialValue: !!isDispetcher ? defaultCreationMethodIdContactCenter : defaultCreationMethodIdWeb,
                  })(
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    showSearch
                    allowClear
                    placeholder="способ создания"
                    notFoundContent='нет данных'
                    optionLabelProp="label"
                    optionFilterProp="searchtext" 
                    disabled={!!isDispetcher}
                  >
                    {dspxGetChildrens(
                      getAvailableCreationMethods(fprops.creationMethods, isDispetcher)
                    )}
                  </Select>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Приоритет">
                {getFieldDecorator('priorityId')(
                  <PriorityList
                    render={({ priorities, ref, props }) => (
                      <Select
                        getPopupContainer={(trigger) => trigger.parentNode}
                        ref={ref}
                        showSearch
                        allowClear
                        placeholder="приоритет"
                        notFoundContent="нет данных"
                        optionLabelProp="label"
                        optionFilterProp="searchtext"
                        {...props}
                      >
                        {priorities?.map((p) => (
                          <Select.Option
                            key={p.id}
                            searchtext={p.name}
                            label={`${p.code} - ${p.name}`}
                            value={p.id}
                          >
                            {p.code} - {p.name}
                          </Select.Option>
                        ))}
                      </Select>

                      // <Select
                      //   ref={ref}
                      //   showSearch
                      //   allowClear
                      //   placeholder="приоритет"
                      //   notFoundContent="нет данных"
                      //   optionLabelProp="label"
                      //   optionFilterProp="searchtext"
                      //   {...props}
                      // >
                      //   {/* {dspxGetChildrens(priorities)} */}
                      // </Select>
                    )}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Дата назначения">
                <Tooltip
                  title={
                    this.isInputDisabled() &&
                    'Меняется в календаре после создания заявки'
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {getFieldDecorator('executeMoment')(
                    <DatePicker
                      format="DD.MM.YYYY"
                      disabled={this.isInputDisabled()}
                    />
                  )}
                </Tooltip>
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item label="Дата контроля">
                  {getFieldDecorator('alertDate', {
                    rules: [{ required: !!isImmediateValue, message: 'Пожалуйста, укажите дату контроля' }]
                  })(
                    <DatePicker
                      allowClear={!isImmediateValue}
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                    />
                  )}
              </Form.Item>
            </Col> */}
          </Row>

          <Row gutter={16}>
          </Row>
          <Row gutter={16}>
            <Col span={6}>
              <ChargeableCheckbox form={this.props.form} />
            </Col>
            <Col span={6}>
              <Form.Item >
                {getFieldDecorator('isImmediate', { initialValue: false })(
                  <IconCheckBox icon={<UrgentIcon />} onChange={(e) => handleChangeImmediate(e)}>
                    Аварийная
                </IconCheckBox>)}
              </Form.Item>
            </Col>
            <Col span={12}>
              {fprops.showPossWarranty && <Form.Item >
                {getFieldDecorator('isPossWarranty', { initialValue: fprops.valuePossWarranty })(
                  <IconCheckBox icon={<PossWarrantyIcon />}
                    onChange={this.handlePossWarranty}
                    canChange={CanChangeWarranty}
                  >
                    Возможно гарантия
                </IconCheckBox>)}
              </Form.Item> }
            </Col>
            <Col span={6}>
              <Form.Item >
                {getFieldDecorator('IsInternal', { initialValue: fprops.valuePossInternal })(
                  <IconCheckBox icon={<ToolIcon />}
                    onChange={this.handlePossInternal}
                  >
                    Внутренняя
                </IconCheckBox>)}
              </Form.Item>
            </Col>
          </Row>
          {canBindCall && (
            <Row gutter={16}>
              <Col>
                <Form.Item>
                  {getFieldDecorator('bindCall', {
                    initialValue: true,
                    valuePropName: 'checked',
                  })(<Checkbox>Прикрепить текущий звонок</Checkbox>)}
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Описание">
                {getFieldDecorator('description')(<TextArea type="textarea" autoSize={{ minRows: 1, maxRows: 2 }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              {getFieldDecorator('showDescriptionToClient', { initialValue: false, valuePropName: 'checked' })(
                <Checkbox style={{ marginBottom: 10 }}>
                  Показывать описание собственнику
          </Checkbox>)}
            </Col>
          </Row>
          {CanAddFileToRequest && (
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="Вложения">
                  <Upload.Dragger
                    name='file'
                    fileList={this.state.fileList}
                    multiple={true}
                    beforeUpload={(file) => {
                      this.setState(({ fileList }) => ({
                        fileList: [...fileList, file]
                      }));
                      return false;
                    }}
                    onRemove={(file) => {
                      this.setState(({ fileList }) => {
                        const index = fileList.indexOf(file);
                        const newFileList = fileList.slice();
                        newFileList.splice(index, 1);
                        return {
                          fileList: newFileList,
                        };
                      });
                    }}>
                    <Icon type="file-add" theme="outlined" /> перетащите файлы сюда, или нажмите, чтобы выбрать
                  </Upload.Dragger>
                </Form.Item>
              </Col>
            </Row>
          )}

        </Form>
      )

      if (!asModal) {
        return content;
      }

			return (
				<Modal className='dspx-icon-header'
					width={520}
					visible={visible}
					title={<span><AddRequestIcon style={{ height: 40, verticalAlign:'middle', marginRight: 10 }}/>Новая заявка</span>}
					okText="Создать"
					onCancel={onCancel}
					onOk={onCreate}
          destroyOnClose
          >
					{content}
				</Modal>
			);
		}
	});

class NewRequestContainer extends Component {
	static contextType = SipPhoneContext;
  state = {
    showCheckModal: false,
    showFormModal: false,
    selectedAddressId: null,
    pendingAddress: null,
  };
//Dispatcher UserInfo authentication
	componentDidMount() {
    this.props.dispatch(actions.fetchShowHintsAndOldRequests())
		this.props.dispatch(actions.fetchAddrStreetList());
    this.props.dispatch(actions.fetchAddServiceCompanyList());
    //this.props.dispatch(actions.fetchServiceList());
		//this.props.dispatch(actions.fetchWorkerList());
		//this.props.dispatch(actions.fetchExecuterList());

    if (this.props.address_by_phone.length > 1) {
      this.setState({ showCheckModal: true });
      return;
    }

    if (this.props.address_by_phone.length === 1) {
      const address = this.props.address_by_phone[0];

      this.setState({
        pendingAddress: address,
        showFormModal: true,
      });

      this.props.dispatch(
        actions.applyAddrStreet(address.streetId)
      );
      return;
    }

    this.setState({ showFormModal: true });
	}

  componentDidUpdate(prevProps) {
  const { pendingAddress } = this.state;

  if (
    pendingAddress &&
    prevProps.listAddrBuilding !== this.props.listAddrBuilding &&
    this.props.listAddrBuilding?.length
  ) {
    this.props.dispatch(
      actions.applyAddrBuilding(pendingAddress.houseId)
    );
  }

  if (
    pendingAddress &&
    prevProps.listAddrFlat !== this.props.listAddrFlat &&
    this.props.listAddrFlat?.length
  ) {
    this.props.dispatch(
      actions.applyAddrFlat(pendingAddress.flatId)
    );

    this.setState({ pendingAddress: null });
  }
}

  componentWillUnmount() {
  if (this.props.onUnmount) {
    this.props.onUnmount();
  }
}


	handleCancel = () => {
		return new Promise((resolve) => {
			const form = this.formRef.props.form;
			const hasTouchedFields = typeof form.isFieldsTouched === 'function' ? form.isFieldsTouched() : false;
			const hasFiles = Array.isArray(this.formRef.state.fileList) && this.formRef.state.fileList.length > 0;

			if (hasTouchedFields || hasFiles) {
				Modal.confirm({
					title: MODAL_UNSAVED_DATA_WARNING_TITLE,
					content: UNSAVED_DATA_WARNING_TEXT,
					okType: 'danger',
					okText: 'Да',
					cancelText: 'Отмена',
					onOk: () => {
						this.resetAndClose();
						resolve(true);
					},
					onCancel: () => {
						resolve(false);
					},
				});
				return;
			}

			this.resetAndClose();
			resolve(true);
		});
	}

	resetAndClose = () => {
		const form = this.formRef.props.form;
		form.resetFields();
		this.formRef.state.fileList = [];
		this.formRef.state.ownerInfo = false;
		this.props.dispatch(actions.applyAddrStreet(undefined));
		this.props.dispatch(actions.resetTermOfExecution());
		this.props.dispatch(actions.closeNewRequestModal());
		this.props.dispatch(actions.clearApplicantList());
		this.props.dispatch(actions.clearStagesLife());
		this.props.dispatch(actions.clearOldRequests());
		this.props.dispatch(actions.clearHintsByRequestType());
		this.props.dispatch(actions.clearHintsByServiceCompany());
    this.props.dispatch(actions.setOwnerData('', ''));
	}

  saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	handleCreate = async () => {
  const form = this.formRef.props.form;

  return new Promise((resolve) => {
    form.validateFields((err, values) => {
      if (err) {
        resolve(false);
        return;
      }
      
      const {
        bindCall,
        phone_number,
        name,
        isPossWarranty,
        executeMoment,
        ...otherValues
      } = values;

      const v = { warrantyId: isPossWarranty ? 2 : 0, ...otherValues };


			if (phone_number) v.phone = `+7${phone_number}`;
      if (name?.trim()) v.name = name.trim();
      if (executeMoment)
        v.executeDate = moment().isSame(executeMoment, 'day')
          ? toDateStr(executeMoment)
          : executeMoment.clone().utc().format();

      const applicant = this.props.applicants.find(a => String(a.id) === v.name);
      if (applicant) {
        v.name = applicant.name;
      }

      const attachments = this.formRef.state.fileList;
      const callId = bindCall ? this.context.call.info?.id : undefined;

      const form = this.formRef.props.form;
      form.resetFields();
      this.formRef.state.fileList = [];
      this.formRef.state.ownerInfo = false;
      this.props.dispatch(actions.postRequest(v, attachments, callId));
      this.props.dispatch(actions.applyAddrStreet(undefined));
      this.props.dispatch(actions.resetTermOfExecution());
      this.props.dispatch(actions.closeNewRequestModal());
      this.props.dispatch(actions.setOwnerData('', ''));
      this.props.dispatch(actions.applyAddrServiceCompany(undefined))
      this.props.dispatch(actions.clearApplicantList());
      this.props.dispatch(actions.clearStagesLife());
      this.props.dispatch(actions.clearOldRequests());

      resolve(true);
    });
  });
}

    handleClickModal = (address) => {
      if (!address) return;

      this.setState({
        pendingAddress: address,
        showCheckModal: false,
        showFormModal: true,
        selectedAddressId: null,
      });

      this.props.dispatch(actions.applyAddrStreet(address.streetId));
    };

renderCheckModal() {
  return (
    <Modal
      visible={this.state.showCheckModal}
      title="Выберите адрес"
      onOk={() => {
        const address = this.props.address_by_phone.find(
          a => a.id === this.state.selectedAddressId
        );
        if (address) this.handleClickModal(address);
      }}
      onCancel={this.handleClickModal}
    >
      <Select         
        style={{ width: '100%' }}
        placeholder="Выберите адрес"
        onChange={(id) => this.setState({ selectedAddressId: id })}
      >
        {this.props.address_by_phone?.map((addr, index) => (
          <Select.Option key={addr.id} value={addr.id}>
            {createFullAddress(addr)}
          </Select.Option>
        ))}
        </Select>
    </Modal>
  );
}

	render() {
    const { asModal = true } = this.props

		return (
      <>  
        {this.renderCheckModal()}
			  <NewRequestForm
          wrappedComponentRef={this.saveFormRef}
          visible={this.props.newRequestModalVisible}
          dispatch={this.props.dispatch}
          onCancel={this.handleCancel}
          onCreate={this.handleCreate}
          fprops={this.props}
          asModal={asModal}
        />
      </>
  
		)
	}
}

function mapStateToProps(state) {
	const { newRequestStore } = state;
	const userInfo = state.authentication.userInfo;
  const { creationMethods } = state.requestsStore;
	return {...newRequestStore, userInfo, creationMethods};
}

const ConnectedContainer = connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }
)(NewRequestContainer);

export default React.forwardRef((props, ref) => (
  <ConnectedContainer {...props} ref={ref} />
));
